import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/components/ui/toast";
import * as api from "./api";

/*
 * useGetAllPreProcessedData Query
 *
 * This returns all the detected AOI's from the pipeline for all assets in a study.
 * It also returns meta data about each asset and an id.
 *
 * Query Key: ["pre-processed-data", projectId, studyId]
 */
export const useGetAllPreProcessedData = (projectId: string, studyId: string) => {
  return useQuery({
    queryKey: ["pre-processed-data", projectId, studyId],
    queryFn: () => api.getAllPreProcessedData(projectId, studyId),
  });
};

/**
 * useUpdateAllData Mutation
 *
 * Saves the user-edited region data for all assets in a study to S3.
 *
 * Mutation Key: ["pre-processed-data", projectId, studyId]
 */
export const useUpdateAllData = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, studyId, assets }: { projectId: string; studyId: string; assets: api.UpdateAllDataAsset[] }) => api.updateAllData(projectId, studyId, assets),
    onError: () => {
      toast({
        title: "Failed to save AOI's, please try again.",
        type: "error",
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["pre-processed-data"] });
    },
  });
};
